export const UNICA_KLASS = 'mshop_unica_klass';
